export const BOOK_INTERVIEW_MISSION_READ_ACCESS_REQUIRED =
  "Ask your workspace admin to upgrade your access to book interviews.";
